<table class="ml-0 text-sm border-separate" style="border-spacing: 1px">
  <thead>
    <tr>
      <th class="bg-gray-800 border border-gray-700 p-1">x|y</th>
      <th *ngFor="let x of xRange" class="bg-gray-800 border border-gray-700 p-1">
        {{ x }}
      </th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let y of yRange">
      <th class="bg-gray-800 border border-gray-700 p-1">{{ y }}</th>
      <td *ngFor="let x of xRange" 
          [title]="getFieldTitle(x, y)" 
          [style.border]="'1px solid ' + getFieldColor(x, y)"
          (click)="onCellClick(x, y)"
          class="cursor-pointer p-0">
        <div class="w-8 h-8 relative" 
             [style.backgroundImage]="'url(' + imageUrl + '/map/' + getField(x, y)?.image + '.gif)'">
           <a [routerLink]="['/stellar-cartography', y, x]" class="absolute inset-0 flex items-center justify-center">
             <div class="font-bold text-center text-white text-shadow">{{ getFieldContent(x, y) }}</div>
           </a>
        </div>
      </td>
    </tr>
  </tbody>
</table>
